<template>
  <div class="trade-order-detail-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" title="订单详情" :showBack="true"></my-header>
      <div class="customer-user-info">
        <img style="width: 0.38rem;height: 0.44rem" src="../../assets/icon/icon-address.png">
        <div class="customer-address-info">
          <div>{{address.address}}</div>
          <span class="customer-name">{{address.receiver}}</span>{{address.phone}}
        </div>
      </div>
      <div class="customer-cart-item">
        <div class="shop-info">
          <div class="shop-name">{{tradeOrder.shopName}}</div>
        </div>
        <div v-for="(orderDetail,index) in tradeOrder.detailList" :class="{'cart-item-padding-top-style':index>0}" class="product-info border-bottom-style">
          <img class="product-img" :src="orderDetail.image">
          <div class="product-sku">
            <div class="product-name">{{orderDetail.name}}</div>
            <div class="sku-item">数量：{{orderDetail.quantity}}</div>
          </div>
          <div class="product-price">{{orderDetail.price}}元/{{orderDetail.unit}}</div>
        </div>
        <div class="trade-order-info">
          <div class="trade-order-info-item">
            <div>订单状态</div>
            <div>{{orderStatusMap[tradeOrder.status]}}</div>
          </div>
          <div class="trade-order-info-item">
            <div>订单编号</div>
            <div>{{tradeOrder.orderNo}}</div>
          </div>
          <div class="trade-order-info-item">
            <div>下单时间</div>
            <div>{{tradeOrder.createTime}}</div>
          </div>
          <div class="trade-order-info-item">
            <div>订单总计</div>
            <div>{{tradeOrder.amount}}</div>
          </div>
        </div>
        <div v-if="tradeOrder.status == '1'" class="trade-order-operation">
          <div @click = "cancelOrder(tradeOrder.id)" class="general-btn">取消订单</div>
          <div @click="payOrder(tradeOrder.id)" class="general-btn general-confirm-btn">去支付</div>
        </div>
      </div>
    <div v-if="isCancelOrder" class="toast general-trade-modal general-box-shadow">
      <div class="general-trade-modal-text">确定要取消订单?</div>
      <div class="confirm-footer" >
        <div class="agree-btn" @click="confirmCancel">确定</div>
        <div class="cancel-btn" @click = "cancel">取消</div>
      </div>
    </div>
    <div v-if="isCancelOrder" class="general-box-bg"></div>
    <div v-if="isPayOrder" class="toast general-trade-modal general-box-shadow">
      <div class="general-trade-modal-text">确定要支付订单?</div>
      <div class="confirm-footer" >
        <div class="agree-btn" @click="payTraderOrder">确定</div>
        <div class="cancel-btn" @click = "cancelPay">取消</div>
      </div>
    </div>
    <div v-if="isPayOrder" class="general-box-bg"></div>

  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import payUtil from '../../utils/Pay'
  import tradeOrderService from '../../service/trade/TradeOrderService'

  export default {
    name: 'TradeOrderList',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        prePayInfo:{},
        tradeOrderId:'',
        address:{},
        tradeOrder:{},
        orderStatusMap:[],
        isCancelOrder:false,
        isPayOrder:false,
        operationOrderId:'',
        isWechatBrowser:this.$verfyBrowserType()
      }
    },
    created(){
      this.tradeOrderId = this.$route.query.tradeOrderId;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getTradeOrderDetail();
    },
    methods: {
      async getTradeOrderDetail(){
        let {code,msg,data} = await tradeOrderService.detail(this.tradeOrderId);
        if(code == '0'){
          this.address = data.address;
          this.tradeOrder = data.order;
          this.orderStatusMap = data.statusMap;
        }
      },
      cancelOrder(id){
        this.operationOrderId = id;
        this.isCancelOrder = true;
      },
      cancel(){
        this.isCancelOrder = false;
      },
      async confirmCancel(){
        tradeOrderService.cancelOrder(this.operationOrderId).then(res =>{
          if(res.code == '0'){
            Toast('取消订单成功!');
            this.isCancelOrder = false;
          }else{
            Toast(res.msg);
          }
        })
      },
      payOrder(id){
        this.operationOrderId = id;
        this.isPayOrder = true;
      },
      cancelPay(){
        this.isPayOrder = false;
      },
      async payTraderOrder(){
        //判断浏览器类型
        var ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger') {
          //微信浏览器
          let result = await tradeOrderService.payOrder(this.operationOrderId,'1');
          if(result.code == '0'){
            this.prePayInfo = payUtil.pay(result.data.prepayId,result.data.nonceStr);
            let requestPay = this.requestPay;
            if (typeof WeixinJSBridge == "undefined"){
              if( document.addEventListener ){
                document.addEventListener('WeixinJSBridgeReady', requestPay, false);
              }else if (document.attachEvent){
                document.attachEvent('WeixinJSBridgeReady', requestPay);
                document.attachEvent('onWeixinJSBridgeReady', requestPay);
              }
            }else{
              this.requestPay();
            }
          } else {
            Toast(result.msg);
          }
        }else {
          //非微信浏览器
          let result = await tradeOrderService.payOrder(this.operationOrderId);
          if(result.code == '0'){
            let payCallBackUrl = result.data.mwebUrl + '&redirect_url=' + window.location.href;
            window.location.href = payCallBackUrl;
          }else {
            Toast(result.msg);
          }
        }
      },
      requestPay(){
        let prePayInfo = this.prePayInfo;
        let that = this;
        try {
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              "appId":prePayInfo.appId,     //公众号名称，由商户传入
              "timeStamp":prePayInfo.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":prePayInfo.nonceStr, //随机串
              "package":prePayInfo.package,
              "signType":prePayInfo.signType,         //微信签名方式：
              "paySign":prePayInfo.paySign //微信签名
            },
            function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                that.isPayOrder = false;
                that.getTradeOrderDetail();
              } else if(res.err_msg == "get_brand_wcpay_request:cancel" ){
                console.info("取消支付");
              }else {
                Toast('支付失败!');
              }// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
              that.isPayOrder = false;
            },function (e) {
              console.error("支付失败err!"+JSON.stringify(e));
              Toast("支付失败!"+JSON.stringify(e));
            });
        }catch (e){
          console.error("支付失败-----!"+JSON.stringify(e));
          Toast("支付失败!"+JSON.stringify(e));
        }
      }
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .trade-order-detail-page {
    height: 100%;
    color: #1B1E29;
    font-size: 0.32rem;
    display: flex;
    flex-direction: column;
    text-align: left;
    .customer-user-info{
      display: flex;
      padding-top: 0.38rem;
      padding-left: 0.3rem;
      padding-bottom: 0.3rem;
      background-color: #f3f8fc;
      .customer-address-info{
        padding-left: 0.4rem;
        .customer-name{
          padding-right: 0.3rem;
        }
      }
    }

    .customer-cart-item{
      background-color: white;
      width: 6.9rem;
      margin-bottom: 0.22rem;
      padding: 0.3rem 0.3rem 0;
      .shop-info{
        display: flex;
        justify-content: space-between;
        position: relative;
        padding-bottom: 0.36rem;
      }
      .product-info{
        padding-bottom: 0.28rem;
        display:flex;
        position:relative;
        .product-img{
          width: 1.54rem;
          height: 1.52rem;
        }
        .product-sku{
          padding-left: 0.3rem;
          .product-name{
            font-size: 0.28rem;
          }
          .sku-item{
            font-size: 0.24rem;
            color: #878e99;
          }
        }
        .product-price{
          color: #ff7544;
          position: absolute;
          bottom: 0rem;
          right: 0rem;
        }
      }
      .product-price{
        text-align: right;
        height: 0.7rem;
        line-height: 0.7rem;
      }
      .trade-order-info{
        padding-top: 0.2rem;
        font-size: 0.24rem;
        color: #878e99;
        .trade-order-info-item{
          display: flex;;
          justify-content: space-between;
        }
      }
      .trade-order-operation{
        font-size: 0.28rem;
        padding: 0.28rem 0;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
</style>
